// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAI } from 'firebase/ai';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const appCheckSiteKey = process.env.VUE_APP_FIREBASE_APPCHECK_SITE_KEY;
const appCheckDebugToken = process.env.VUE_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;

if (appCheckDebugToken) {
  // Required before initializeAppCheck when using the debug provider.
  // true → SDK generates a token (register it in Firebase Console); UUID string → use that token.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
    appCheckDebugToken === 'true' ? true : appCheckDebugToken;
}

if (appCheckSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn(
    '[App Check] VUE_APP_FIREBASE_APPCHECK_SITE_KEY is empty. ' +
      'Gemini via Firebase AI Logic will fail after App Check enforcement (Nov 2, 2026).'
  );
}

const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
/** Same region as the deployed callables. */
export const functions = getFunctions(app, 'us-central1');
export const ai = getAI(app, { useLimitedUseAppCheckTokens: true });
export { analytics };
